import RateListItemView from 'app/views/rate_list_item_view';
import Base from 'app/views/base';

import tmpl from 'templates/rate_list';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize() {
    this.listenTo(this.collection, 'reset', this.render);
  },

  beforeRender() {
    this.removeSubviews();
    this.collection.each((rate) => {
      this.addSubview(
        `rate_${rate.id}`,
        `#rate_${rate.id}`,
        new RateListItemView({ model: rate })
      );
    });
  },

  context() {
    return {
      rates: this.collection.models,
    };
  },
});



// WEBPACK FOOTER //
// ./app/views/rate_list_view.js